<template>
  <div>
    <d-header></d-header>
    <div class="setting">
     <b-row>
       <b-col class="mx-5 mt-5">
         <p style="font-size: 36px">รายการตั้งค่า</p>
       </b-col>
     </b-row>
      <b-row>
        <b-col class="mx-5 px-5">
          <a class="action_link" @click="settingPoliceStation"><b-icon-circle-fill></b-icon-circle-fill> ตั้งค่าสถานีตำรวจ</a>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mx-5 px-5">
          <a class="action_link" @click="settingDoctor"><b-icon-circle-fill></b-icon-circle-fill> ตั้งค่าแพทย์ชันสูตรร่วม</a>
        </b-col>
      </b-row>
    </div>
    <d-footer></d-footer>
  </div>
</template>

<script>
import DHeader from "../components/Header";
import DFooter from "../components/Footer";
export default {
name: "Setting",
  components:{
    DHeader,
    DFooter,
  },
  methods:{
    settingPoliceStation(){
      const path = `/settingListPoliceStation`
      if (this.$route.path !== path) this.$router.push(path)
    },
    settingDoctor(){
      const path = `/settingDoctor`
      if (this.$route.path !== path) this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.setting{
  height: 100%;
  min-height: 100vh!important;
  color: #2DA1A9;
}
.action_link{
  font-size: 24px;
  color: #2DA1A9;
}
.action_link:hover{
  color: #247980;
}
</style>
